import { ApiContext } from '@/chat_client/ApiChatClient'

export default async function getCurrentBearerToken({
  client,
  config,
}: ApiContext): Promise<string> {
  return '4b31d155bd4c3d95322125b6d076179ddc187c6f'
}
